import React from 'react';
import styled from 'styled-components';

const CompanyLogoWrapper = styled.div`
  display: flex;
  margin: 0 auto 20px;
  align-items: center;
  justify-content: center;

  img.company-logo-img {
    object-fit: none;
    display: block;
  }
`;
const CompanyLogo = ({
  src = process.env.REACT_APP_COMPANY_LOGO,
  alt = process.env.REACT_APP_APP_NAME,
}: {
  src?: string;
  alt?: string;
}) => {
  return (
    <CompanyLogoWrapper>
      <img src={src} alt={alt} className={'company-logo-img'} data-testid={'company-logo-img'} />
    </CompanyLogoWrapper>
  );
};

export default CompanyLogo;
